import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { UIComponentHandler, UIComponentImpl, UIComponentProps, UIComponentState, UIDataModel } from '../../../toolkit/uicomponent';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { InfoCSSStyleImpl } from './infocss';
import { InfoViewImpl } from './infoview';

export interface InfoComponentProps extends UIComponentProps
{
    headerTitle: string;
    closePopup(): void;
    onOkClick():void;
}

export interface InfoComponentHandler extends UIComponentHandler
{
    closePopup(): void;
    onOkClick(): void;
    onCancelClick():void;
}

export class InfoComponent extends UIComponentImpl<InfoComponentProps, UIComponentState, UIDataModel> 
implements InfoComponentHandler
{
    constructor(props: InfoComponentProps)
    {
        super(props);
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new InfoViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new InfoCSSStyleImpl(applicationContext);
    }

    // protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    // {
    //      return new AddNameTunesAPIModelImpl(applicationContext, apiModelHandler);
    // }

    onOkClick(): void 
    {
        // if(this.getView().validate())
        // {
        //     (this.getAPIModel() as AddNameTunesAPIModel).addNameTunes(this.props.searchKey);

        // }
    }

    onCancelClick():void
    {
        this.props.closePopup();
    }


    closePopup():void
    {
        this.props.closePopup();
    }
    // onSuccess(feature: APIFeatures, description: string, data: any): void 
    // {
    //     console.log("On Success of confirm request ^^^^^^");
    //     this.props.showPopup("Your Order completed successfully.",AlertType.SUCCESS, "Ok"); 
       
    // }

    // onFailure(feature: APIFeatures, description: string, data: any): void 
    // {
    //     this.props.showPopup(description,AlertType.ERROR, "Ok"); 
      
    // }
   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/info/infocomponent.tsx